function showFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').show();
}

function hideFabricCanvasLoader() {
  jQuery('#fabricCanvasLoader').fadeOut(300);
}


function runWithLoader(task) {
  showFabricCanvasLoader();

  // frame 1 → show loader
  requestAnimationFrame(() => {
    // frame 2 → do heavy work
    requestAnimationFrame(() => {
      task();

      // hide loader AFTER render
      setTimeout(hideFabricCanvasLoader, 150);
    });
  });
}

var text,fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1400, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;


imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');


let starimage = document.querySelector("#stars_background");
let starBackground = new fabric.Image(starimage, {
  left: 0,   
  top: 0,
  scaleX: 2,
  scaleY: 2,
  selectable: false
});

window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});


window['canvas2'].add(starBackground);
starBackground.sendToBack();


addModify(window['canvas2']);


let isFirstRender = true;
let starMapGroup = null;

document.addEventListener("DOMContentLoaded", () => {
    if (!window['canvas2']) {
        console.error("canvas2 not found");
        return;
    }

    /* =============================== GLOBALS ================================ */
    let pickedCoords = { lat: 31.5546, lon: 74.3572 }; // Default Lahore
    let lastQueryId = 0;
    
    let starDatabase = [];
    let constellationLinesData = [];
    let isDataLoaded = false;

    const locationInput = document.getElementById("user_location");
    const suggestions = document.getElementById("suggestions");
    const dateInput = document.getElementById("moon_date");
    const coordsInput = document.getElementById("text_3");

    /* =============================== LOAD ASTRONOMY DATA ================================ */
    async function loadAstronomyData() {
        try {
            const starUrl = 'https://raw.githubusercontent.com/ofrohn/d3-celestial/master/data/stars.6.json';
            const linesUrl = 'https://raw.githubusercontent.com/ofrohn/d3-celestial/master/data/constellations.lines.json';

            const [starRes, linesRes] = await Promise.all([
                fetch(starUrl),
                fetch(linesUrl)
            ]);

            const starData = await starRes.json();
            const linesData = await linesRes.json();

            // 1. Parse Star Data
            starDatabase = {};
            starData.features.forEach(feature => {
                if (feature.geometry && feature.geometry.coordinates) {
                    const id = feature.id;
                    const coords = feature.geometry.coordinates;
                    starDatabase[id] = {
                        ra: coords[0],
                        dec: coords[1],
                        mag: feature.properties.mag
                    };
                }
            });

            // 2. Parse Constellation Lines
            constellationLinesData = [];
            
            linesData.features.forEach(f => {
                if (!f.geometry || !f.geometry.coordinates) return;
                let segments = [];
                if (f.geometry.type === 'LineString') {
                    segments = [f.geometry.coordinates];
                } else if (f.geometry.type === 'MultiLineString') {
                    segments = f.geometry.coordinates;
                }

                segments.forEach(segment => {
                    for (let i = 0; i < segment.length - 1; i++) {
                        const p1 = segment[i];
                        const p2 = segment[i+1];
                        constellationLinesData.push({
                            ra1: p1[0], dec1: p1[1],
                            ra2: p2[0], dec2: p2[1]
                        });
                    }
                });
            });

            isDataLoaded = true;
            updateStarMap(); 

        } catch (err) {
            console.error("Failed to load star data", err);
        }
    }

    loadAstronomyData();

    /* =============================== HELPERS ================================ */
    function formatCoords(lat, lon) {
        const latDir = lat >= 0 ? "N" : "S";
        const lonDir = lon >= 0 ? "E" : "W";
        return `${Math.abs(lat).toFixed(4)}° ${latDir} - ${Math.abs(lon).toFixed(4)}° ${lonDir}`;
    }

    function updateCanvasText(lat, lon) {

        const coords = formatCoords(lat, lon);

        const dateText = window.dateCoordsText
            ? window.dateCoordsText.text.split('|')[0].trim()
            : '';

        updateDateAndCoords(dateText, coords);

    }

    function updateCoordinatesInput(lat, lon) {
        if (coordsInput) coordsInput.value = formatCoords(lat, lon);
        updateCanvasText(lat, lon);
    }
    
    function updateLocationText(text) {
        if (window.text4Page) {
            window.text4Page.set("text", text);
            window.text4Page.bringToFront();
            window['canvas2'].renderAll();
        }
    }

    function updateDateText(dateStr) {

        const date = new Date(dateStr);

        if (isNaN(date)) return;

        const options = { day: "2-digit", month: "long", year: "numeric" };

        const formatted = date.toLocaleDateString("en-GB", options);

        const coordsText = window.text3Page
          ? window.text3Page.text
          : formatCoords(pickedCoords.lat, pickedCoords.lon);

        updateDateAndCoords(formatted, coordsText);

    }

    /* =============================== AUTOCOMPLETE ================================ */
    if (locationInput) {
        locationInput.addEventListener("input", async (e) => {
            const q = e.target.value.trim();
            suggestions.innerHTML = "";
            suggestions.style.display = "none";
            if (q.length < 2) return;

            const queryId = ++lastQueryId;
            try {
                const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=6&q=${encodeURIComponent(q)}`);
                if (queryId !== lastQueryId) return;
                const data = await res.json();
                if (!data.length) return;

                suggestions.style.display = "block";
                data.forEach(place => {
                    const div = document.createElement("div");
                    div.className = "autocomplete-item";
                    div.textContent = place.display_name;
                    div.onclick = () => {
                        locationInput.value = place.display_name;
                        pickedCoords = { lat: parseFloat(place.lat), lon: parseFloat(place.lon) };
                        suggestions.style.display = "none";
                        updateCoordinatesInput(pickedCoords.lat, pickedCoords.lon);
                        
                        const parts = place.display_name.split(",");
                        const city = parts[0];
                        const country = parts[parts.length - 1];
                        updateLocationText(`${city}, ${country}`);
                        updateStarMap();
                    };
                    suggestions.appendChild(div);
                });
            } catch (e) { console.warn(e); }
        });
    }

    if (coordsInput) {
        coordsInput.addEventListener("input", function() {
            const val = this.value.trim();
            const m = val.match(/(-?\d+\.?\d*).*?([NS]).*?(-?\d+\.?\d*).*?([EW])/i);
            if (!m) return;
            let lat = parseFloat(m[1]); if (m[2].toUpperCase() === 'S') lat = -lat;
            let lon = parseFloat(m[3]); if (m[4].toUpperCase() === 'W') lon = -lon;
            pickedCoords = { lat, lon };
            updateStarMap();
        });
    }

    /* =============================== ASTRONOMY MATH ================================ */
    
    function getHorizonCoordinates(ra, dec, dateObj, lat, lon) {
        const observer = new Astronomy.Observer(lat, lon, 0);
        const raHours = ra / 15.0;
        const skyPos = Astronomy.Horizon(dateObj, observer, raHours, dec, 'normal');
        return { altitude: skyPos.altitude, azimuth: skyPos.azimuth };
    }

    function projectToCanvas(alt, az) {

        const center = 0; // important for grouping
        const mapRadius = 340;

        const zenithDist = (90.0 - alt);
        const r = (zenithDist / 90.0) * mapRadius;

        const azRad = az * Math.PI / 180.0;

        const x = center - r * Math.sin(azRad);
        const y = center - r * Math.cos(azRad);

        return { x, y };
    }

    function drawStarMap() {
        if (!isDataLoaded) return;
        
        if (starMapGroup) window['canvas2'].remove(starMapGroup);
        const objs = [];

        // Date Logic: 22:00 (10 PM) standard for star posters
        const dateVal = dateInput ? dateInput.value : "2020-10-20";
        let dateObj = new Date(dateVal + " 22:00:00"); 
        
        const lat = pickedCoords.lat;
        const lon = pickedCoords.lon;

        // REMOVED: Background circle. 
        // The map will now render directly on the canvas without a circular mask/background.

        // 1. Prepare Stars
        const visibleStars = [];
        for (const id in starDatabase) {
            const star = starDatabase[id];
            if (star.mag > 5) continue; 

            const horizon = getHorizonCoordinates(star.ra, star.dec, dateObj, lat, lon);
            if (horizon.altitude > 0) {
                const pos = projectToCanvas(horizon.altitude, horizon.azimuth);
                visibleStars.push({ ...star, x: pos.x, y: pos.y });
            }
        }

        // 2. Draw Constellation Lines
        constellationLinesData.forEach(line => {
            const h1 = getHorizonCoordinates(line.ra1, line.dec1, dateObj, lat, lon);
            const h2 = getHorizonCoordinates(line.ra2, line.dec2, dateObj, lat, lon);

            if (h1.altitude > -5 && h2.altitude > -5) {
                const p1 = projectToCanvas(h1.altitude, h1.azimuth);
                const p2 = projectToCanvas(h2.altitude, h2.azimuth);

                objs.push(new fabric.Line([p1.x, p1.y, p2.x, p2.y], {
                    stroke: "rgba(255, 255, 255, 0.8)", 
                    strokeWidth: 2,
                    selectable: false,
                    evented: false
                }));
            }
        });

        // 3. Draw Stars
        visibleStars.forEach(s => {
            const radius = Math.max(1.2, (6 - s.mag) * 0.5); 
            objs.push(new fabric.Circle({
                left: s.x, top: s.y,
                radius: radius,
                fill: "white",
                stroke: "rgba(255, 255, 255, 0.8)",
                strokeWidth: 2,
                originX: 'center', originY: 'center',
                selectable: false, evented: false
            }));
        });

        // STAR MAP POSITION
        const starMapLeft = 715;   // adjust X position
        const starMapTop  = 930;   // adjust Y position

        starMapGroup = new fabric.Group(objs, {
            left: starMapLeft,
            top: starMapTop,
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false
        });

        window['canvas2'].add(starMapGroup);
        starMapGroup.moveTo(1);
        window['canvas2'].renderAll();
    }

    function updateStarMap() {
        if (dateInput && !dateInput.value) return;
        if (typeof runWithLoader === 'function') runWithLoader(() => drawStarMap());
        else drawStarMap();
    }

    if (dateInput) {
        dateInput.addEventListener("change", function() {
            updateDateText(this.value);
            updateStarMap();
        });
    }

    updateCoordinatesInput(pickedCoords.lat, pickedCoords.lon);
    if (isDataLoaded) updateStarMap();
});



var maxWidth = 1200;
var maxHeight = 240;

var para = "check" ;

window['text2Page'] = new fabric.Text(para,{
  left: 680,
  top: 1570,
  width: 1200,
  fontSize: 120,
  fontFamily: 'Great Vibes',
  // fontWeight: 'bolder',
  textAlign: 'center',
  isWrapping: true,
  fill: '#000'
});


var fontName = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName + "'").trigger('change');

window['canvas2'].add(window['text2Page']);


var minFontSize = 20;
var maxFontSize = 120;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Under this sky a star was born') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text2Page'].set({
    text: input
  });
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}




window['text1Page'] = new fabric.Text('Muhammad Humza',{
  left: 690,
  top: 1745,
  fontSize: 110,
  fontFamily: 'Dancing Script',
  underline: true,
  fill: '#000',
  // fontWeight: 'bolder',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font1').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Muhammad Humza') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 110; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 1250);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});



window['text4Page'] = new fabric.Text('Karachi, Pakistan',{
  left: 690,
  top: 1885,
  fontSize: 40,
  fontFamily: 'Poppins',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

window['canvas2'].add(window['text4Page']);


document.getElementById('user_location').addEventListener('focus', function () {
  if (window['text4Page'].text === 'Karachi, Pakistan') {
    window['text4Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


window['dateCoordsText'] = new fabric.Text(
  '22 May, 2025 | 24.8547° N - 67.0207° E',
  {
    left: 690,
    top: 1940,
    originX: 'center',
    fontSize: 40,
    fontFamily: 'Poppins',
    fill: '#000',
    lockMovementX: true,
    lockMovementY: true,
    hasControls: false,
    selectable: false
  }
);

window.canvas2.add(window['dateCoordsText']);

function updateDateAndCoords(dateText, coordsText) {

  const finalText = `${dateText} | ${coordsText}`;

  if(window.dateCoordsText){
    window.dateCoordsText.set('text', finalText);

    if(typeof fitTextToWidth3 === 'function'){
        fitTextToWidth3(window.dateCoordsText, 1250);
    }

    window.dateCoordsText.bringToFront();
    window.canvas2.renderAll();
  }

}


function fitTextToWidth3(textObj, maxWidth) {
  let fontSize = 40;
  textObj.set({ fontSize });

  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window.canvas2.renderAll();
}





window['text55Page'] = new fabric.Text('@tasweer.com.pk',{
  left: 1310,
  top: 1960,
  fontSize: 14,
  fontFamily: 'Baloo2',
  fill: '#000',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});


window['canvas2'].add(window['text55Page']);




function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

}

// jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(window['canvas2']);
  });

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    newImg.set({
      left: img.left,
      top: img.top,
      selectable: img.selectable
    });
    newImg.scaleToHeight(available_height);
    canvas.add(newImg).renderAll();
    img = newImg;
    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToWidth(window['text1Page'], 1250);
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});


function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

function updateFont(activeOb){
  if(activeOb){
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',fontSize);
    activeOb.set('fontFamily',fontFamily);
    activeOb.set('fill',activeCOLOR);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});




jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Muhammad Humza');
  window['text2Page'].set('text','Under this sky a star was born');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});



/* fetch Call */
var size,thumbnail;
var loadedObject,moonDate,selectlocation,enterText,textFont,coordinates,enterQuote,quoteFont,additionalInfo,wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 406;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    // hideExtras(canvas);
    window['canvas2'] = canvas.toDataURL('image/png');
    moonDate = jQuery('.moon_date input').val();
    selectlocation = jQuery('.location_map input').val();
    enterText = jQuery('.enter_text input').val();
    textFont = jQuery('.choose_font1 option:selected').val();
    coordinates = jQuery('.coordinates_map input').val();
    enterQuote = jQuery('.enter_quote textarea').val();
    quoteFont = jQuery('.choose_font2 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    // showExtras(canvas);
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#moonDate').val(moonDate);
      jQuery('#selectlocation').val(selectlocation);
      jQuery('#enterText').val(enterText);
      jQuery('#textFont').val(textFont);
      jQuery('#coordinates').val(coordinates);
      jQuery('#enterQuote').val(enterQuote);
      jQuery('#quoteFont').val(quoteFont);
      jQuery('#addInfo').val(additionalInfo);
      console.log('Server response:', data);
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
      loader.addClass('hidden');
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}